module.exports = "/fonts/vendor/quasar-extras/fontawesome/fa-regular-400.woff2?bdadb6ce95c5a2e7b673940721450d3c";


//////////////////
// WEBPACK FOOTER
// ./node_modules/quasar-extras/fontawesome/fa-regular-400.woff2
// module id = /wvw
// module chunks = 49